import type { FC } from 'react'
import { Box } from '@mui/material'

// Inherit default HTML button props
type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

/**
 * This is a bare HTML button with style overrides for general use
 */
export const Button: FC<ButtonProps> = props => {
  return (
    <Box
      component="button"
      {...props}
      sx={{ background: 0, border: 'none', cursor: 'pointer', font: 'inherit', padding: 0 }}
    />
  )
}
